import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import moment from "moment";
import { useState } from "react";

import { useHistory } from "react-router";
import { Pagination } from "@mui/material";

import { decryption } from "../../../HelperFunctions";

import { useMutation, useQuery } from "@apollo/client";

import { GET_ALL_JOB_POSTS } from "@/GraphQL/Queries";
import ListsLayout from "@/shared/components/Layouts/ListsLayout";
import { DELETE_JOB_POST } from "@/GraphQL/Mutation";
import Swal from "sweetalert2";

const JobListTable = () => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  // permission
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );

  const { data, loading, error, refetch } = useQuery(GET_ALL_JOB_POSTS, {
    variables: {
      page: currentPage,
      size: limit,
    },
    fetchPolicy: "network-only",
  });
  console.log(
    "🚀 ~ JobListTable ~ data:",
    data?.getAllJobPosts?.paginatorInfo?.total
  );

  const [deleteJobPost] = useMutation(DELETE_JOB_POST, {
    onCompleted: (data) => {
      if (data?.deleteJobPost?.result_code === "000") {
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "The Job Post has been deleted successfully!",
        });
        refetch(); // Refresh the notice list after deletion
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.deleteJobPost.status,
        });
      }
    },
    onError: (error) => {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "System error. Please contact the system admin.",
      });
      console.error("Error deleting notice:", error);
    },
  });

  const deleteHandler = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteJobPost({ variables: { id } });
      }
    });
  };

  const tableHeader = (
    <tr>
      <th>Sl No</th>
      <th>Job Title</th>
      <th>Work Place</th>
      <th>Salary</th>
      <th>Dead Line</th>
      {permissions?.includes("update_holyday") && <th>Actions</th>}
      <th>Status</th>
    </tr>
  );
  const tableBody = data?.getAllJobPosts?.data?.map((item, index) => (
    <tr key={item?.id}>
      <td>{index + 1}</td>

      <td>{item?.job_title}</td>
      <td>{item?.work_place}</td>
      <td>{`${item?.salary}`}</td>
      <td>{moment(Number(item?.dead_line)).format("MMMM D, YYYY")}</td>
      {permissions?.includes("delete_holyday") && (
        <td>
          {permissions?.includes("delete_holyday") ? (
            <button
              className="inbox__email-btn"
              type="button"
              aria-label="edit"
              onClick={(e) => {
                e.stopPropagation();
                deleteHandler(item?.id);
              }}
            >
              <DeleteIcon fontSize="small" />
            </button>
          ) : null}
          {permissions?.includes("update_holyday") ? (
            <button
              className="inbox__email-btn mr-1"
              type="button"
              aria-label="edit"
              onClick={() =>
                history.push({
                  pathname: "/job_post/new",
                  state: {
                    updateData: item,
                  },
                })
              }
            >
              <EditIcon fontSize="small" />
            </button>
          ) : null}
          {permissions?.includes("update_holyday") ? (
            <button
              className="inbox__email-btn mr-1"
              type="button"
              aria-label="edit"
              onClick={() =>
                history.push({
                  pathname: "/job_post/details",
                  state: {
                    updateData: item,
                  },
                })
              }
            >
              <VisibilityIcon fontSize="small" />
            </button>
          ) : null}
        </td>
      )}
      {/* <td>
        {new Date(Number(item?.dead_line)) >=
        new Date(new Date().toDateString()) ? (
          <div style={{ textAlign: "start" }}>
            <CheckCircleIcon fontSize="small" sx={{ color: "green" }} />
          </div>
        ) : (
          <div style={{ textAlign: "start" }}>
            <RemoveCircleIcon fontSize="small" sx={{ color: "red" }} />
          </div>
        )}
      </td> */}
      <td>
        {item?.is_active ? (
          <div style={{ textAlign: "start" }}>
            <CheckCircleIcon fontSize="small" sx={{ color: "green" }} />
          </div>
        ) : (
          <div style={{ textAlign: "start" }}>
            <RemoveCircleIcon fontSize="small" sx={{ color: "red" }} />
          </div>
        )}
      </td>
    </tr>
  ));
  const handleChange = (e, p) => {
    setCurrentPage(p);
    refetch({
      page: p,
    });
  };

  return (
    <>
      <p className="fw-bold ml-3">
        <strong> Total: {data?.getAllJobPosts?.paginatorInfo?.total}</strong>
      </p>
      <ListsLayout
        tableHeader={tableHeader}
        tableBody={tableBody}
        loading={loading}
      ></ListsLayout>
      {data?.getAllJobPosts?.data?.length > 0 ? (
        <Pagination
          className="mt-2"
          count={data?.getAllJobPosts?.paginatorInfo?.lastPage}
          page={data?.getAllJobPosts?.paginatorInfo?.currentPage}
          onChange={handleChange}
        />
      ) : null}
    </>
  );
};

export default JobListTable;
